var n=function(n){var e=n.href,t=n.onClick,l=n.onKeyDown;return function(n){null==l||l(n),n.defaultPrevented||" "!==n.key||(null==t||t(n),!n.defaultPrevented&&e&&location.assign(e))}};export{n as onAnchorKeyDown};
